import { render, staticRenderFns } from "./SalesOrderStatusBatchId.vue?vue&type=template&id=c2b39dfa&"
import script from "./SalesOrderStatusBatchId.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusBatchId.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusBatchId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports